import { z } from 'zod/v3';

export const SAAS_APPLICATION_SCHEMA_VERSION = 1;

export const SaasApplication = z.object({
  externalId: z.string(),
  displayName: z.string(),
  technicalName: z.string().nullable(),
  status: z.enum(['active', 'inactive', 'deleted', 'unknown']),
  signOnMode: z.enum(['saml', 'oidc', 'password_vault', 'bookmark', 'native', 'unknown']),
  applicationKind: z.enum(['first_party', 'third_party', 'system', 'unknown']),
  features: z.array(z.string()),
  createdAt: z.string().datetime().nullable(),
  updatedAt: z.string().datetime().nullable(),
});

export type SaasApplication = z.infer<typeof SaasApplication>;
